module.exports = __webpack_public_path__ + "img/HierNochEinZopf.2ca5f12f.svg";